import { createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "section-featured-projects py-5" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h3", { class: "section-title font-weight-bold text-center mb-5" }, " Featured Projects ", -1)
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("View all projects")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProjectsGrid = _resolveComponent("ProjectsGrid")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_ProjectsGrid, { projects: _ctx.projects }, null, 8, ["projects"]),
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_router_link, {
          class: "btn btn-primary",
          to: { name: 'projects' }
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ])
    ])
  ]))
}